import Login from './Login';
import Logout from './Logout';
import GetPromotions from './GetPromotions';
import GetPromotionDetail from './GetPromotionDetail';
import EnterDrawTicket from './EnterDrawTicket';
import GetEntries from './GetEntries';
import GetPlayerData from './GetPlayerData';
import GetDrawings from './GetDrawings';
import GetGames from './GetGames';
import PostFeedback from './PostFeedback';
import SetEntryFlashGameFlag from './SetEntryFlashGameFlag';
import GetBanners from './GetBanners';
import GetConfig from './GetConfig';

export default {
    login: Login,
    logout: Logout,
    enterDrawTicket: EnterDrawTicket,
    getEntries: GetEntries,
    getPromotions: GetPromotions,
    getPromotionDetail: GetPromotionDetail,
    getPlayerData: GetPlayerData,
    getDrawings: GetDrawings,
    getConfig: GetConfig,
    postFeedback: PostFeedback,
    getGames: GetGames,
    getBanners: GetBanners,
    setEntryFlashGameFlag: SetEntryFlashGameFlag,
};
